
import { startViewTransition } from '@theme/utilities';
import { sectionRenderer } from '@theme/section-renderer';
const PaginationProducts = class extends HTMLElement {
    connectedCallback() {
        const links = this.querySelectorAll('a');
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                this._onLinkClicked(event, link, this.sectionId);
            });
        });
    }
    get sectionId() {
        const id = this.getAttribute('data-section-id');
        if (!id) throw new Error('Section ID is required');
        return id;
    }
    _onLinkClicked(event, target, sectionId) {
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('page', target.getAttribute('data-page'));

        history.pushState(null, null, url.toString()); 
        startViewTransition(() => sectionRenderer.renderSection(sectionId), ['product-grid']);

        const header = document.querySelector('.header__row');
        const scrollTarget = document.querySelector('.cls-list');

        if (header && scrollTarget) {
        const headerHeight = header.offsetHeight;
        const targetTop = scrollTarget.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
            top: targetTop - headerHeight,
            behavior: 'smooth' // 平滑滚动
        });
        }
    }
};
window.customElements.define('pagination-products', PaginationProducts);